<template>
	<div class="item">
		<div>
			<div class="item-img">
				<img :alt="itemProduct.name_title" :src="itemProduct.sku_info[skuIndex].ali_image+'?x-oss-process=image/resize,w_206/quality,Q_80/format,webp'" style="opacity: 1;">
			</div>
			<h6>{{itemProduct.name}}</h6>
			<h3>{{itemProduct.name_title}}</h3>
			<div class="item-model ">
				<i>型号：</i><span>{{itemProduct.model}}</span>
			</div>
			<div class="params-colors">
				<ul class="colors-list">
					<li v-for="(item,index) in itemProduct.sku_info">
						<a href="javascript:;" @click="tab(index)" :title="item.spec_json.show_name" :class="{'active':index==skuIndex}">
							<img :src="'http://img01.smartisanos.cn/'+item.spec_json.image+'/20X20.jpg'"></a>
					</li>
				</ul>
			</div>			
			<div class="item-cover" v-if="detailFlag">
				<router-link :to="{name:'detailcontroller',query:{productId:itemProduct.id}}"></router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				skuIndex:0,
				detailFlag:this.$store.state.detailFlag
			}
		},
		props: {
			itemProduct: Object
		},
		methods:{
			tab(index){
				console.log(index);
				this.skuIndex = index;
			}

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/item-controller.vue